import React from 'react'

import Counter from '../Counter/Counter'

import styles from './TopBar.module.scss'

const TopBar = ({ title, currentTabNumber, allTabsNumber, onButtonClick }) => (
    <div className={styles.topBar}>
        <div className={styles.title}>{title}</div>
        <Counter
            current={currentTabNumber}
            all={allTabsNumber}
            className={styles.counter}
            onButtonClick={onButtonClick}
        />
    </div>
)

export default TopBar
